var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 219,
    viewBox: "0 0 197 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.9543 49.0999L88.261 62.2533L103.956 56.5156L94.6309 70.3825L104.938 83.5359L88.8679 78.9527L79.5432 92.8196L78.9363 76.1202L62.8666 71.537L78.5612 65.7993L77.9543 49.0999Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M95.8088 97.9385L106.115 111.092L121.81 105.354L112.485 119.221L122.792 132.375L106.722 127.791L97.3977 141.658L96.7908 124.959L80.7211 120.376L96.4157 114.638L95.8088 97.9385Z",
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.663 146.777L123.97 159.931L139.665 154.193L130.34 168.06L140.647 181.213L124.577 176.63L115.252 190.497L114.645 173.798L98.5756 169.214L114.27 163.477L113.663 146.777Z",
    fill: "#F1F1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.307 28.4986L144.614 41.652L160.308 35.9143L150.983 49.7812L161.29 62.9346L145.22 58.3514L135.896 72.2183L135.289 55.5188L119.219 50.9357L134.914 45.198L134.307 28.4986Z",
    fill: "#F1F1F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.161 77.3372L162.468 90.4906L178.163 84.7529L168.838 98.6198L179.145 111.773L163.075 107.19L153.75 121.057L153.143 104.357L137.074 99.7743L152.768 94.0366L152.161 77.3372Z",
    fill: "#F1F1F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M170.016 126.176L180.322 139.329L196.017 133.592L186.692 147.458L196.999 160.612L180.929 156.029L171.605 169.896L170.998 153.196L154.928 148.613L170.623 142.875L170.016 126.176Z",
    fill: "#F1F1F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M190.658 7.89725L200.965 21.0506L216.66 15.313L207.335 29.1799L217.642 42.3333L201.572 37.7501L192.247 51.617L191.64 34.9175L175.571 30.3343L191.265 24.5967L190.658 7.89725Z",
    fill: "#F1F1F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M208.513 56.7359L218.82 69.8893L234.514 64.1516L225.189 78.0185L235.496 91.1719L219.427 86.5887L210.102 100.456L209.495 83.7562L193.425 79.173L209.12 73.4353L208.513 56.7359Z",
    fill: "#F1F1F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.6017 69.7012L31.9084 82.8546L47.603 77.117L38.2783 90.9838L48.585 104.137L32.5154 99.554L23.1907 113.421L22.5838 96.7215L6.51409 92.1383L22.2087 86.4007L21.6017 69.7012Z",
    fill: "#F1F1F1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.4562 118.54L49.7629 131.693L65.4575 125.956L56.1328 139.822L66.4395 152.976L50.3699 148.393L41.0452 162.26L40.4383 145.56L24.3686 140.977L40.0631 135.239L39.4562 118.54Z",
    fill: "#F1F1F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M57.3107 167.379L67.6174 180.532L83.312 174.794L73.9873 188.661L84.294 201.815L68.2244 197.231L58.8997 211.098L58.2927 194.399L42.2231 189.816L57.9176 184.078L57.3107 167.379Z",
    fill: "#F1F1F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup7);
export default __webpack_public_path__ + "static/media/Group 7.db000d6ae01143c41f43dc7b2fce0f74.svg";
export { ForwardRef as ReactComponent };